import { Box, Flex, Link, Text, useBreakpointValue } from "@chakra-ui/react";
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
import ContentArea from "./ContentArea";
import { modifyDatoImgUrlToStatic } from "./utils";


let AvailableStores = ({ sectionContent, sectionId }) => {
    return <Flex id={sectionId} bgColor={'#EFE7D6'} height={{ base: "554px", md: "419px", xl: '317px' }} alignItems={'center'}
        flexDir={{ base: 'column', xl: 'row' }}
        justifyContent={'center'} gap={{ base: 10, md: 10, xl: 10, '2xl': 20 }}
        pl={{base: '20px', md: '0px'}}
    >
        <Box mr={{base:'0px', xl: '20px'}}>
            <Text
                mb={{base: '-10px', md: '15px'}}
                fontFamily={'var(--AustinMedium)'}
                fontSize={{ base: '34px', md: '60px' }}
                lineHeight={{ base: "60px", md: '60px' }}
                color={'#030040'}
                fontWeight={500}
            >{sectionContent?.[0]?.titleText}</Text>
            <Text
                fontFamily={'var(--FedraSansStd-book)'}
                color={'#000000'}
                fontSize={{ base: '18px', md: '24px' }}
                lineHeight={{ base: "34px", md: '24px' }}
                fontWeight={400}
            >{sectionContent?.[0]?.titleSubtext}</Text>
        </Box>
        <Box>
            <Flex flexDir={{ base: 'column', md: 'row' }} justifyContent={'center'} alignItems={'center'} gap={{ base: 5, md: 10 }}>
                {sectionContent?.slice(1).map((i, j) => {
                    let imgSrc = useBreakpointValue({base: modifyDatoImgUrlToStatic(i?.mobileImage?.url), md: modifyDatoImgUrlToStatic(i?.image?.url)})
                    if (j % 2 == 0) {
                        return <Link display={'inline-block'} alignSelf={'center'} target="_blank" href={sectionContent?.slice(1)?.[j + 1]?.linkUrl}> <LazyLoadImageComponent
                            src={imgSrc}
                        />
                        </Link>
                    }
                })}
            </Flex>
        </Box>
    </Flex>

}

export default AvailableStores